import FooterCommon from './FooterCommon.jsx';

export default function FooterDefault() {
  return <FooterCommon />;
}
